import './CustomerFeedbackPopup.css';
import { tTeamMember } from '../data/Team';

interface HireEmployeePopupProps {
  availableDevelopers: tTeamMember[];
  hireEmployeeCallback: (developerId: number) => void;
}

// Helper function to get job title (same logic as TeamMemberCard)
function getJobTitleForSkillLevel(skillLevel: number): string {
  enum eJobTitle {
    Trainee = 0.25,
    JuniorDeveloper = 0.5,
    JuniorSoftwareDeveloper = 0.75,
    Developer = 1,
    SoftwareEngineer = 1.25,
    SeniorSoftwareDeveloper = 1.5,
    LeadDeveloper = 1.75  
  }

  if (skillLevel >= eJobTitle.Trainee && skillLevel < eJobTitle.JuniorDeveloper) {
    return "Trainee";
  } else if (skillLevel >= eJobTitle.JuniorDeveloper && skillLevel < eJobTitle.JuniorSoftwareDeveloper) {
    return "Junior Developer";
  } else if (skillLevel >= eJobTitle.JuniorSoftwareDeveloper && skillLevel < eJobTitle.Developer) {
    return "Junior Software Developer";
  } else if (skillLevel === eJobTitle.Developer) {
    return "Developer";
  } else if (skillLevel > eJobTitle.Developer && skillLevel <= eJobTitle.SoftwareEngineer) {
    return "Software Engineer";
  } else if (skillLevel > eJobTitle.SoftwareEngineer && skillLevel <= eJobTitle.SeniorSoftwareDeveloper) {
    return "Senior Software Developer";
  } else if (skillLevel > eJobTitle.SeniorSoftwareDeveloper && skillLevel <= eJobTitle.LeadDeveloper) {
    return "Lead Developer";
  } else {
    return "Unknown Skill Level";
  }
}

export default function HireEmployeePopup(props: HireEmployeePopupProps) {
  return (
    <div className="popup-overlay">
      <div className={`customer-feedback-popup-modal`}>
        <h3>👥 Hire New Employee</h3>
        
        <p style={{ marginBottom: '20px', textAlign: 'center', color: '#666' }}>
          Select a developer to join your team:
        </p>
        
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
          {props.availableDevelopers.map((developer) => {
            const jobTitle = getJobTitleForSkillLevel(developer.level);
            const wage = developer.level * 50;
            
            return (
              <div 
                key={developer.id}
                style={{
                  padding: '15px',
                  border: '2px solid #ddd',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  backgroundColor: '#f9f9f9'
                }}
                onClick={() => props.hireEmployeeCallback(developer.id)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = '#007bff';
                  e.currentTarget.style.backgroundColor = '#fff';
                  e.currentTarget.style.transform = 'scale(1.02)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = '#ddd';
                  e.currentTarget.style.backgroundColor = '#f9f9f9';
                  e.currentTarget.style.transform = 'scale(1)';
                }}
              >
                <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                  <span style={{ fontSize: '48px' }}>{developer.icon}</span>
                </div>
                <div>
                  <h4 style={{ margin: '5px 0', textAlign: 'center' }}>{developer.name}</h4>
                  <p style={{ margin: '5px 0', fontSize: '12px', color: '#666', textAlign: 'center' }}>
                    {jobTitle}
                  </p>
                  <p style={{ margin: '5px 0', fontSize: '12px', textAlign: 'center' }}>
                    <strong>Specialty:</strong> {developer.skill}
                  </p>
                  <p style={{ margin: '5px 0', fontSize: '12px', textAlign: 'center' }}>
                    <strong>Wage:</strong> £{wage}/sprint
                  </p>
                  <p style={{ margin: '10px 0 5px 0', fontSize: '11px', color: '#666', fontStyle: 'italic' }}>
                    {developer.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
